module.exports = __webpack_public_path__ + "static/media/logo-word-long.48d4eef9.svg";